import React from "react";

export const UserPhotoRightStarsIcon = () => {
  return (
    <svg
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="right-starts-icon"
    >
      <g clipPath="url(#clip0_15415_5115)">
        <path
          d="M24.1135 9.28985C19.3867 9.5749 15.6042 13.3575 15.3192 18.0842H15.2847C14.9996 13.3575 11.2171 9.5749 6.49048 9.28985V9.25533C11.2171 8.97028 14.9996 5.18779 15.2847 0.460938H15.3192C15.6042 5.18779 19.3867 8.97028 24.1135 9.25533V9.28985Z"
          fill="#EBBD46"
        />
      </g>
      <g clipPath="url(#clip1_15415_5115)">
        <path
          d="M10.2668 20.6154C7.5658 20.7783 5.40439 22.9398 5.2415 25.6408H5.22178C5.05889 22.9398 2.89747 20.7783 0.196533 20.6154V20.5957C2.89747 20.4328 5.05889 18.2714 5.22178 15.5703H5.2415C5.40439 18.2714 7.5658 20.4328 10.2668 20.5957V20.6154Z"
          fill="#EBBD46"
        />
      </g>
      <defs>
        <clipPath id="clip0_15415_5115">
          <rect
            width="17.6233"
            height="17.6233"
            fill="white"
            transform="translate(6.49023 0.460938)"
          />
        </clipPath>
        <clipPath id="clip1_15415_5115">
          <rect
            width="10.0705"
            height="10.0705"
            fill="white"
            transform="translate(0.196289 15.5703)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
